"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTicketHTML = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const translations_1 = require("./translations/translations");
const interfaces_1 = require("./interfaces");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const generateTicketHTML = (ticket, lang = 'en', margin, demo) => {
    var _a;
    const translation = translations_1.translations[lang];
    return `<!DOCTYPE html>
  <html>
    <head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Oxygen&family=Rubik&display=swap" rel="stylesheet">
      <style>
      a,
      div,
      span,
      * {
        margin: 0px;
        margin-top: 0px;
        margin-left: 0px;
        margin-bottom: 0px;
        margin-right: 0px;
        padding: 0px;
        padding-top: 0px;
        padding-left: 0px;
        padding-bottom: 0px;
        padding-right: 0px;
        box-sizing: border-box;
      }
        .${interfaces_1.PREFIX}card {
          position: relative;
          padding: 20px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          margin:${margin ? 1 : 0}px;
          width: 300px;
          height:559px;
          box-sizing: unset;
          display: flex;
          flex-direction: column;
          background-color: #fff;
          overflow: clip;
        }
  
        .${interfaces_1.PREFIX}organizer-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          column-gap: 8px;
        }
  
        .${interfaces_1.PREFIX}organizer-data {
          display: flex;
          flex-direction: column;
          flex: 1;
        }
  
        .${interfaces_1.PREFIX}font-primary {
          font-family: 'Rubik';
          font-weight: 400;
        }
        .${interfaces_1.PREFIX}font-secondary{
          font-family:'Oxygen';
          font-weight:400;
        }
        .${interfaces_1.PREFIX}text-ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1; /* number of lines to show */
          line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-word;
        }
  
        .${interfaces_1.PREFIX}organizator-label {
          font-size: 12px;
          line-height: 12px;
          
        }
  
        .${interfaces_1.PREFIX}organizator-name {
          margin-top: 7px;
          font-size: 15px;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* number of lines to show */
          line-clamp: 2;
        }
  
        .${interfaces_1.PREFIX}organizer-url {
          font-size: 10px;
          line-height: 12px;
          margin-top: 8px;
        }
  
        .${interfaces_1.PREFIX}qrcode {
          display: flex;
          justify-content: center;
          margin: 24px 0px;
        }
  
        .${interfaces_1.PREFIX}qrcode-image {
          max-width: 201px;
          max-height: 201px;
        }
  
        .${interfaces_1.PREFIX}entry-ticket {
          font-size: 15px;
          line-height: 18px;
          margin-block-start: 0px;
          margin-block-end: 0px;
          font-family: 'Oxygen';
        }
  
        .${interfaces_1.PREFIX}event-name {
          font-size: 15px;
          font-weight: 600;
          line-height: 18px;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* number of lines to show */
          line-clamp: 2;
          margin-block-start: 8px;
          margin-block-end: 0px;
        }
  
        .${interfaces_1.PREFIX}svg {
          width: 18px;
          height: 18px;
          min-width: 18px;
          min-height: 18px;
          max-height: 18px;
          max-width: 18px;
        }
  
        .${interfaces_1.PREFIX}footer {
          display: flex;
          flex: 1;
          align-items: flex-end;
          justify-content: space-between;
        }
  
        .${interfaces_1.PREFIX}svg-wrapper {
          display: flex;
          margin-bottom: 8px;
        }
  
        .${interfaces_1.PREFIX}brand-name {
          font-size: 10px;
          line-height: 12px;
          color: rgba(18, 14, 47, 0.3);
          display:${demo ? 'none' : 'block'};
        }
  
        .${interfaces_1.PREFIX}svg-label {
          margin-left: 12px;
          font-size: 15px;
          line-height: 18px;
        }
  
        .${interfaces_1.PREFIX}more-info {
          margin-top: 8px;
          margin-bottom: 12px;
          font-size: 15px;
          line-height: 22.5px;
          text-decoration: none;
          color: rgba(92, 68, 236, 1);
        }
  
        .${interfaces_1.PREFIX}svg-label.place {
          display: -webkit-box;
          -webkit-line-clamp: 2; /* number of lines to show */
          line-clamp: 2;
          color: rgba(92, 68, 236, 1);
        }
  
        .${interfaces_1.PREFIX}divider {
          height: 1px;
          background-color: rgba(0, 0, 0, 0.1);
          width: 100%;
          margin-top: 18px;
          margin-bottom: 12px;
        }
  
        .${interfaces_1.PREFIX}organizer-logo {
          width: max-content;
          height: max-content;
          max-height: 50px;
          max-width: 50px;
        }
        .${interfaces_1.PREFIX}disabled {
          pointer-events: none;
          cursor: default;
        }
        .${interfaces_1.PREFIX}hide{
          display:none;
        }
        .${interfaces_1.PREFIX}svg-flag{
          position: absolute;
          display: ${demo ? 'flex' : 'none'};
          flex-flow: row nowrap;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.1);
          column-gap: 15px;
          top: 250px;
          left: -120px;
          transform: rotate(45deg);
          font-weight: 700;
          font-size: 13.6px;
          line-height: 17px;
          color: #fff;
          width: 770px;
          height: 32px;
          align-items: center;
          justify-content: flex-start;
          z-index: 0;
        }
        .${interfaces_1.PREFIX}card-content{
          position: relative;
          flex: 1;
          flex-direction: column;
          display: flex;
        }
        .${interfaces_1.PREFIX}demo-sign{
          display:${demo ? 'block' : 'none'};
        }
        .${interfaces_1.PREFIX}ticket-demo-mark {
          position: relative;
          display: ${demo ? 'flex' : 'none'};
        }
        .${interfaces_1.PREFIX}ticket-demo-mark-text {
          position: absolute;
          top: 0px;
          right: 5px;
          height: 22px;
          width: 115px;
          display:flex;
          font-size: 13px;
          color: #fff;
          font-family: 'Oxygen';
          align-items: center;
          justify-content: flex-end;
        }
      .${interfaces_1.PREFIX}svg-div {
        height: 18px;
        width: 18px;
      }
      </style>
    </head>
    <body>
      <div class="${interfaces_1.PREFIX}card">
      <div class="${interfaces_1.PREFIX}svg-flag">
              <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
        <p>DEMO</p>
      </div>
      <div class="${interfaces_1.PREFIX}card-content">
        <div class="${interfaces_1.PREFIX}organizer-container">
          <div class="${interfaces_1.PREFIX}organizer-data">
            <span class="${interfaces_1.PREFIX}font-primary ${interfaces_1.PREFIX}organizator-label">${translation.ticket.organizer}</span>
            <span class="${interfaces_1.PREFIX}font-primary ${interfaces_1.PREFIX}text-ellipsis ${interfaces_1.PREFIX}organizator-name">${ticket.organizer}</span>
          </div>
        <img src="${ticket.organizerLogo}" alt="organizer logo" class="${interfaces_1.PREFIX}organizer-logo ${!ticket.organizerLogo && `${interfaces_1.PREFIX}hide`}" />
        </div>
  
        <div class="${interfaces_1.PREFIX}divider"></div>
  
        <span class="${interfaces_1.PREFIX}font-secondary ${interfaces_1.PREFIX}entry-ticket">${translation.ticket.ticketLabel}</span>
        <span class="${interfaces_1.PREFIX}font-primary ${interfaces_1.PREFIX}text-ellipsis ${interfaces_1.PREFIX}event-name">${ticket.eventName}</span>
  
        <a href="${ticket.eventWebsite}" class="${interfaces_1.PREFIX}font-secondary ${interfaces_1.PREFIX}more-info">
          <span>${translation.ticket.moreInfo}</span>
        </a>
  
        <div class="${interfaces_1.PREFIX}svg-wrapper">
                  <div class="${interfaces_1.PREFIX}svg-div">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.33333 1V3M13.6667 1V3M1 15V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H15C15.5304 3 16.0391 3.21071 16.4142 3.58579C16.7893 3.96086 17 4.46957 17 5V15M1 15C1 15.5304 1.21071 16.0391 1.58579 16.4142C1.96086 16.7893 2.46957 17 3 17H15C15.5304 17 16.0391 16.7893 16.4142 16.4142C16.7893 16.0391 17 15.5304 17 15M1 15V8.33333C1 7.8029 1.21071 7.29419 1.58579 6.91912C1.96086 6.54405 2.46957 6.33333 3 6.33333H15C15.5304 6.33333 16.0391 6.54405 16.4142 6.91912C16.7893 7.29419 17 7.8029 17 8.33333V15"
                stroke="#5C44EC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        
          <span class="${interfaces_1.PREFIX}font-secondary ${interfaces_1.PREFIX}svg-label ${interfaces_1.PREFIX}text-ellipsis">
            ${dayjs_1.default.utc(ticket.eventFromTimestamp).tz(ticket.timezone).format('DD.MM.YYYY HH:mm')}
          </span>
        </div>
  
        <div class="${interfaces_1.PREFIX}svg-wrapper">
                  <div class="${interfaces_1.PREFIX}svg-div">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8002 8.0002C10.8002 8.7428 10.5052 9.45499 9.98009 9.98009C9.45499 10.5052 8.7428 10.8002 8.0002 10.8002C7.25759 10.8002 6.5454 10.5052 6.0203 9.98009C5.49519 9.45499 5.2002 8.7428 5.2002 8.0002C5.2002 7.25759 5.49519 6.5454 6.0203 6.0203C6.5454 5.49519 7.25759 5.2002 8.0002 5.2002C8.7428 5.2002 9.45499 5.49519 9.98009 6.0203C10.5052 6.5454 10.8002 7.25759 10.8002 8.0002V8.0002Z"
                stroke="#5C44EC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15 8C15 14.6659 8 18.5 8 18.5C8 18.5 1 14.6659 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8V8Z"
                stroke="#5C44EC"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        
  <a href="${ticket.location.url}" class="${interfaces_1.PREFIX}font-secondary ${interfaces_1.PREFIX}text-ellipsis ${interfaces_1.PREFIX}svg-label place ${!ticket.location.url && `${interfaces_1.PREFIX}disabled`}">
  <span>${(_a = ticket.location.name) !== null && _a !== void 0 ? _a : '-'}</span>
  </a>
        </div>
  
        <div class="${interfaces_1.PREFIX}qrcode">
          <img src="data:image/png;base64, ${ticket.qrCode}" alt="QRCode" class="${interfaces_1.PREFIX}qrcode-image" />
        </div>
  
        <div class="${interfaces_1.PREFIX}footer">
          <svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.3">
              <path
                d="M56.7793 0.910598H56.1855V2.96931H56.7793V1.86077C56.7793 1.61927 56.9576 1.43715 57.1951 1.43715C57.2822 1.43715 57.3535 1.45695 57.4089 1.49258V0.859131C57.1278 0.859131 56.9179 0.946226 56.7793 1.12439V0.910598Z"
                fill="#120E2F"
              />
              <path
                d="M53.5442 2.71197C53.7541 2.91784 54.0194 3.02077 54.3321 3.02077C54.6449 3.02077 54.9061 2.91784 55.116 2.71197C55.3258 2.50214 55.4327 2.2448 55.4327 1.93995C55.4327 1.6351 55.3258 1.37777 55.116 1.1719C54.9061 0.962065 54.6449 0.859131 54.3321 0.859131C54.0194 0.859131 53.7541 0.962065 53.5442 1.1719C53.3344 1.37777 53.2314 1.6351 53.2314 1.93995C53.2314 2.2448 53.3344 2.50214 53.5442 2.71197ZM54.3321 2.43483C54.1935 2.43483 54.0787 2.38733 53.9876 2.29231C53.8966 2.19729 53.849 2.07852 53.849 1.93995C53.849 1.80139 53.8966 1.68261 53.9876 1.5876C54.0787 1.49258 54.1935 1.44507 54.3321 1.44507C54.4667 1.44507 54.5815 1.49258 54.6726 1.59155C54.7676 1.68657 54.8151 1.80139 54.8151 1.93995C54.8151 2.07852 54.7676 2.19333 54.6726 2.29231C54.5815 2.38733 54.4667 2.43483 54.3321 2.43483Z"
                fill="#120E2F"
              />
              <path
                d="M50.8841 2.96911L51.2087 1.88433L51.5295 2.96911H52.0679L52.7211 0.9104H52.1232L51.8026 2.05457L51.4779 0.9104H50.9316L50.6109 2.05457L50.2902 0.9104H49.6924L50.3417 2.96911H50.8841Z"
                fill="#120E2F"
              />
              <path
                d="M47.6865 1.42528H47.9676V2.31211C47.9676 2.49819 48.0349 2.65654 48.1735 2.78324C48.312 2.90597 48.4862 2.96931 48.6881 2.96931H49.0286V2.41504H48.7871C48.6565 2.41504 48.5615 2.32398 48.5615 2.1973V1.42528H49.0286V0.910603H48.5615V0.510742H47.9676V0.910603H47.6865V1.42528Z"
                fill="#120E2F"
              />
              <path
                d="M42.0586 2.96931H42.6525V1.80534C42.6525 1.57968 42.8148 1.40944 43.0325 1.40944C43.2502 1.40944 43.4086 1.57968 43.4086 1.80534V2.96931H44.0025V1.64698C44.0025 1.42131 43.9273 1.23524 43.7728 1.0848C43.6224 0.93435 43.4364 0.859131 43.2146 0.859131C42.9771 0.859131 42.791 0.946226 42.6525 1.12043V0.910598H42.0586V2.96931Z"
                fill="#120E2F"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M46.9656 1.93884C46.9656 2.01414 46.9578 2.08547 46.942 2.15284H45.4223C45.489 2.37081 45.6815 2.51348 45.921 2.51348C46.0213 2.51348 46.0951 2.48654 46.1599 2.43892L46.5421 2.82455C46.3615 2.98152 46.1953 3.02074 45.9171 3.02074C45.599 3.02074 45.3319 2.91771 45.1199 2.71163C44.9078 2.50555 44.8018 2.24795 44.8018 1.93884C44.8018 1.63369 44.9038 1.37609 45.112 1.17001C45.3201 0.959975 45.5754 0.856934 45.8856 0.856934C46.192 0.856934 46.4472 0.959975 46.6553 1.17001C46.8635 1.37609 46.9656 1.63369 46.9656 1.93884ZM45.8856 1.3642C45.6775 1.3642 45.493 1.50291 45.4262 1.71295H46.3647C46.2902 1.50291 46.1056 1.3642 45.8856 1.3642Z"
                fill="#120E2F"
              />
              <path
                d="M58.0479 2.96929H58.6417V2.08642L59.2871 2.96929H59.9997L59.2119 1.90431L59.9245 0.910584H59.2237L58.6417 1.71823V0H58.0479V2.96929Z"
                fill="#120E2F"
              />
              <path
                d="M2.19296 5.88077H5.70532L5.70801 5.87808H9.83245L4.30741 11.4031C3.91872 11.7918 3.84229 12.1247 3.84774 12.3507C3.85389 12.6031 3.96696 12.8678 4.17821 13.0791C4.38953 13.2904 4.65416 13.4035 4.90651 13.4096C5.13235 13.4152 5.46512 13.3387 5.85365 12.9502L12.0405 6.76331C12.9409 5.86294 14.0259 5.42371 15.1212 5.45036C16.1901 5.4764 17.1498 5.94345 17.8407 6.63441C18.5316 7.32538 18.9984 8.2852 19.0244 9.35395C19.0511 10.4491 18.612 11.5341 17.7116 12.4344L14.2146 15.9314H10.0902L15.6494 10.3722C16.0378 9.98377 16.1144 9.65092 16.1088 9.42493C16.1027 9.17243 15.9896 8.90772 15.7784 8.6964C15.567 8.48508 15.3025 8.37208 15.0502 8.36594C14.8243 8.36041 14.4914 8.43684 14.1028 8.82553L7.91587 15.0124C7.0155 15.9128 5.93047 16.3519 4.8353 16.3251C3.76655 16.2991 2.8068 15.8321 2.11591 15.1412C1.42502 14.4502 0.958133 13.4904 0.932169 12.4215C0.905591 11.3263 1.34483 10.2413 2.2452 9.34089L3.51805 8.06804H0L2.19296 5.88077Z"
                fill="#120E2F"
              />
              <path
                d="M29.8866 15.9313H26.8085C26.829 15.8581 26.8396 15.7821 26.8396 15.7038C26.8396 15.4528 26.7238 15.2403 26.4921 15.0473C26.0479 14.6611 25.5845 14.5066 24.8121 14.2555L24.619 14.1975C24.4709 14.1525 24.3336 14.1096 24.2077 14.0703C23.956 13.9916 23.7499 13.9272 23.5955 13.8886L22.6492 13.541C22.2437 13.3672 21.9348 13.232 21.7224 13.0968C21.6982 13.0796 21.6732 13.0618 21.6473 13.0435C21.2379 12.7521 20.6237 12.3151 20.3513 11.861C20.0616 11.3782 19.8105 10.683 19.8105 9.89128C19.8105 8.65538 20.2354 7.65124 21.0851 6.89813C21.954 6.12566 23.0741 5.7395 24.4451 5.7395C25.6617 5.7395 26.7238 6.04846 27.6121 6.64709C28.5197 7.24572 29.0797 7.99883 29.3307 8.90642L26.2989 9.62097C26.1252 9.02233 25.4107 8.55882 24.503 8.55882C23.5762 8.55882 22.881 9.02233 22.881 9.65953C22.881 10.0651 23.2479 10.432 24.001 10.741C24.2714 10.8375 24.9472 11.0499 26.0286 11.3782C26.859 11.6293 27.2838 11.7645 28.0563 12.2279C29.1763 12.8265 29.8328 13.7727 29.9101 15.4334C29.9101 15.604 29.9023 15.7699 29.8866 15.9313Z"
                fill="#120E2F"
              />
              <path
                d="M30.8262 15.9315H33.7228V11.6253L36.8705 15.9315H40.3464L36.5035 10.737L39.9795 5.88999H36.5615L33.7228 9.82938V1.44849H30.8262V15.9315Z"
                fill="#120E2F"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M50.0982 10.8534C50.0982 11.2203 50.0595 11.5679 49.9823 11.8962H42.5091C42.8373 12.9582 43.7836 13.6534 44.9615 13.6534C45.4547 13.6534 45.8179 13.5221 46.1366 13.2902L48.0157 15.1693C47.1279 15.934 46.3102 16.1252 44.9422 16.1252C43.378 16.1252 42.0649 15.6232 41.0221 14.6189C39.9794 13.6148 39.458 12.3596 39.458 10.8534C39.458 9.36645 39.9601 8.11127 40.9835 7.10712C42.007 6.08362 43.2622 5.58154 44.7878 5.58154C46.294 5.58154 47.5492 6.08362 48.5727 7.10712C49.5961 8.11127 50.0982 9.36645 50.0982 10.8534ZM44.7878 8.05335C43.7643 8.05335 42.8567 8.72918 42.5284 9.75268H47.1437C46.7768 8.72918 45.8691 8.05335 44.7878 8.05335Z"
                fill="#120E2F"
              />
              <path
                d="M50.9047 17.5154C52.1599 17.5154 52.9517 17.0133 53.3185 16.0092L53.3764 15.8547L49.5723 5.89038H52.5654L54.7475 12.0891L57.0069 5.89038H60L55.7323 16.9747C55.134 18.4707 54.3183 19.4113 53.1503 19.8902L50.7755 17.5154H50.9047Z"
                fill="#120E2F"
              />
            </g>
          </svg>

          <span class="${interfaces_1.PREFIX}brand-name">skey.network</span>
          <div class="${interfaces_1.PREFIX}ticket-demo-mark">
            <svg width="115" height="22" viewBox="0 0 115 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.7179 0H115V21.9231H10.7179L0 10.9615L10.7179 0Z" fill="#FF6B6B" />
            </svg>
            <p class="${interfaces_1.PREFIX}ticket-demo-mark-text">${translation.ticket.demo}</p>
          </div>
        </div>
        </div>
      </div>
    </body>
  </html> 
`;
};
exports.generateTicketHTML = generateTicketHTML;
